import { render, staticRenderFns } from "./AutoReviewTemplateEdit.vue?vue&type=template&id=fdab7840&scoped=true&"
import script from "./AutoReviewTemplateEdit.vue?vue&type=script&lang=ts&"
export * from "./AutoReviewTemplateEdit.vue?vue&type=script&lang=ts&"
import style0 from "./AutoReviewTemplateEdit.vue?vue&type=style&index=0&id=fdab7840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdab7840",
  null
  
)

export default component.exports